import React from 'react';
import { useToast } from '../../contexts/ToastContext';

const ToastDemo = () => {
  const { 
    showSuccess, 
    showError, 
    showWarning, 
    showInfo, 
    showLoading, 
    showTransaction,
    showConfirmation,
    clearAllToasts 
  } = useToast();

  const demoToasts = [
    {
      label: 'Success Toast',
      action: () => showSuccess('Operation completed successfully!', {
        action: {
          label: 'View Details',
          onClick: () => console.log('View details clicked')
        }
      }),
      color: '#10b981'
    },
    {
      label: 'Error Toast',
      action: () => showError('Something went wrong!', {
        message: 'Please try again or contact support if the problem persists.'
      }),
      color: '#ef4444'
    },
    {
      label: 'Warning Toast',
      action: () => showWarning('Please check your wallet balance before proceeding'),
      color: '#f59e0b'
    },
    {
      label: 'Info Toast',
      action: () => showInfo('New features are now available in the trading dashboard'),
      color: '#3b82f6'
    },
    {
      label: 'Loading Toast',
      action: () => {
        const loadingId = showLoading('Processing transaction...');
        // Auto-remove after 3 seconds for demo
        setTimeout(() => {
          showSuccess('Transaction completed!');
        }, 3000);
      },
      color: '#6366f1'
    },
    {
      label: 'Transaction Toast',
      action: () => showTransaction('buy', 'SOL', '1.5', 'mock_tx_hash_123'),
      color: '#10b981'
    },
    {
      label: 'Confirmation Toast',
      action: () => showConfirmation(
        'Are you sure you want to delete this wallet? This action cannot be undone.',
        () => showSuccess('Wallet deleted successfully!'),
        () => showInfo('Deletion cancelled')
      ),
      color: '#f59e0b'
    }
  ];

  return (
    <div style={{ 
      padding: '20px', 
      background: 'white', 
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      margin: '20px'
    }}>
      <h3 style={{ marginBottom: '20px', color: '#2c3e50' }}>
        🍞 Toast Notifications Demo
      </h3>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px',
        marginBottom: '20px'
      }}>
        {demoToasts.map((toast, index) => (
          <button
            key={index}
            onClick={toast.action}
            style={{
              padding: '12px 16px',
              background: toast.color,
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.2s ease',
              transform: 'translateY(0)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {toast.label}
          </button>
        ))}
      </div>

      <div style={{ 
        display: 'flex', 
        gap: '12px',
        justifyContent: 'center',
        paddingTop: '16px',
        borderTop: '1px solid #e9ecef'
      }}>
        <button
          onClick={clearAllToasts}
          style={{
            padding: '10px 20px',
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Clear All Toasts
        </button>
        
        <button
          onClick={() => {
            // Show multiple toasts at once
            showSuccess('First success message');
            setTimeout(() => showWarning('Second warning message'), 500);
            setTimeout(() => showInfo('Third info message'), 1000);
            setTimeout(() => showError('Fourth error message'), 1500);
          }}
          style={{
            padding: '10px 20px',
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Show Multiple Toasts
        </button>
      </div>

      <div style={{ 
        marginTop: '20px', 
        padding: '16px',
        background: '#f8f9fa',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#6c757d'
      }}>
        <strong>Features:</strong>
        <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
          <li>Beautiful animations with slide-in effects</li>
          <li>Auto-dismiss with progress bar</li>
          <li>Action buttons for interactive toasts</li>
          <li>Stacking with visual depth</li>
          <li>Responsive design for mobile</li>
          <li>Dark mode support</li>
          <li>Hover to pause auto-dismiss</li>
        </ul>
      </div>
    </div>
  );
};

export default ToastDemo;